import { style } from '@vanilla-extract/css'

export const note = style({
  fontSize: '13px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  color: '#828282',
})

export const noteIcon = style({
  paddingTop: '3px',
})

export const card = style({
  display: 'flex',
  flexFlow: 'column nowrap',
  alignItems: 'start',
  gap: '8px',
  borderRadius: '16px',
  padding: '16px',
  backgroundColor: 'white',
  boxShadow: '0px 8px 16px 0px #C5C5C50D',
  width: '100%',
  textDecoration: 'none',
})

export const cardHeading = style({
  fontSize: '15px',
  fontWeight: '700',
  textWrap: 'pretty',
})

export const statusLabel = style({
  display: 'inline-block',
  backgroundColor: '#eeeeee',
  borderRadius: '4px',
  padding: '2px 6px',
  fontSize: '12px',
  fontWeight: '700',
})

export const nextDate = style({
  fontSize: '19px',
  fontWeight: '700',
})

export const date = style({
  fontSize: '15px',
  fontWeight: '700',
})

export const skipped = style({
  fontSize: '15px',
  fontWeight: '700',
  color: '#979797',
})

export const text = style({
  fontSize: '13px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
})

export const warn = style([
  text,
  {
    color: '#ED0006',
  },
])

export const boldLink = style({
  fontSize: '13px',
  fontWeight: '700',
  textDecoration: 'underline',
})

export const recentDeliveryImage = style({
  width: '15%',
  maxWidth: '56px',
  aspectRatio: '1 / 1',
  borderRadius: '8px',
  objectFit: 'cover',
})

export const changeLink = style({
  fontSize: '13px',
  fontWeight: '700',
})
